/* 🤖 this file was generated by svg-to-ts*/
export const icoTwitter: {
  name: 'twitter';
  data: string;
} = {
  name: 'twitter',
  data: `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_2406_33755" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="6" y="6" width="20" height="20">
  <path d="M26 6H6V26H26V6Z" fill="white"/>
  </mask>
  <g mask="url(#mask0_2406_33755)">
  <path d="M17.9027 14.4643L25.3482 6H23.5838L17.119 13.3494L11.9555 6H6L13.8082 17.1136L6 25.9897H7.76443L14.5915 18.2285L20.0445 25.9897H26L17.9027 14.4643ZM15.4861 17.2115L14.695 16.1049L8.40018 7.29901H11.1102L16.1902 14.4056L16.9813 15.5123L23.5847 24.7498H20.8746L15.4861 17.2115Z" fill="#E9F2FF"/>
  </g>
  </svg>`
};
